import React from "react";
import { Link } from "react-router-dom";

const VARIANTS = [
  { v: "v1", name: "Cinematic", desc: "Liftfoils-inspired full-bleed video. Editorial typography. Scroll storytelling.", img: "https://images.unsplash.com/photo-1769816325482-59769ff9ab37?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { v: "v2", name: "Showroom Premium", desc: "Split hero. Refined microinteractions. Carbon close-ups.", img: "https://images.unsplash.com/photo-1763075958748-9a0c9c8799c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { v: "v3", name: "Adventure Lifestyle", desc: "Vibrant bento grid. Playful gradients. Lifestyle-first.", img: "https://images.unsplash.com/photo-1593547103424-4aa8c049b952?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { v: "v4", name: "Tech-Spec Forward", desc: "Floating data chips. Animated infographics. Apple-Watch vibe.", img: "https://images.unsplash.com/photo-1667478828745-0b3ec0c3f97a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { v: "v5", name: "Editorial Magazine", desc: "Vol 01. Big typography. Field reports. Narrative.", img: "https://images.unsplash.com/photo-1502680390469-be75c86b636f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
];

export default function VariantsIndex() {
  return (
    <main className="pt-24 pb-32 bg-[#FAFAF7] min-h-screen" data-testid="variants-index">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="overline mb-3">Choose your homepage</div>
        <h1 className="font-serif-display text-5xl md:text-7xl text-slate-900">5 directions.</h1>
        <p className="text-slate-600 mt-4 max-w-xl">Open each variant, pick your favorite, and we'll lock it in as the default.</p>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {VARIANTS.map((vr) => (
            <Link key={vr.v} to={`/${vr.v}`} className="group card-clean overflow-hidden block" data-testid={`variant-${vr.v}`}>
              <div className="aspect-[4/3] overflow-hidden bg-slate-100">
                <img src={vr.img} alt={vr.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-7">
                <div className="overline">/{vr.v}</div>
                <div className="font-serif-display text-3xl mt-2 text-slate-900 group-hover:text-sky-500 transition-colors">{vr.name}</div>
                <p className="text-slate-600 text-sm mt-3">{vr.desc}</p>
                <div className="mt-5 text-xs uppercase tracking-[0.2em] font-ui text-sky-500">View →</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
}
